export default __webpack_public_path__ + "static/media/Spring_Break_3_2.90972ca7.png";